/*******
* js file for photo lightbox
*
********/
var current_slide;
var next_slide;

$(document).ready( function() {
	GallerySlider();
    Popups();
    PhotoGallerySlider();
});


/**
 * On ajax completion
 **/
$(document).ajaxComplete(function(){
    //GallerySlider();
   // ChangeSlide();
    PhotoGallerySlider();
});

function GallerySlider(){

    // when slider nav button is clicked
    $(document).on('click', '.slider-nav-arrow', function(){

        current_slide = $(this).parents('.slider').children('.slide.current');
        var direction = $(this).data('direction');

        // if next has been clicked
        if(direction == 'next'){

            // determine the next slide
            if(current_slide.next('.slide').length){
                // if there's a slide after the current one, target it
                next_slide = current_slide.next('.slide');
                
            }else{
                // otherwise we're at the start of the list; loop back to the first slide
                next_slide = $(this).parents('.slider').children('.slide').first();
            }

        }

        // if prev has been clicked
        else{

            // determine the next slide
            if(current_slide.prev('.slide').length){
                // if there's a slide before the current one, target it
                next_slide = current_slide.prev('.slide');
                
            }else{
                // otherwise we're at the end of the list; loop back to the last slide in the list
                next_slide = $('.slide').last();
            }
        }

        // console.info('current slide:' + $(current_slide).attr('id'));
        // console.info('next slide:' + $(next_slide).attr('id'));
        //console.info(next_slide);

        // change the slide
        ChangeSlide(current_slide, next_slide);

    });
}

/**
 * Fade out the current slide and fade in the next one
 * @param {slide obj} current_slide [the slide to be faded out]
 * @param {slide obj} next_slide    [the slide to be faded in]
 */
function ChangeSlide(current_slide, next_slide){

    // update slides
    current_slide.stop().fadeOut().removeClass('current');
    next_slide.stop().fadeIn().addClass('current');

}

/**
 * Pop Up
 */
function Popups(){
    $('.popup-trigger').click(function(){
       // $('.popup').toggleClass('hide');
        $('.popup').fadeIn(100);
    });

    $('.popup .close').click(function(){
        //$('.popup').toggleClass('hide');
        $('.popup').fadeOut(100);
        $('.popup .popup-content').html('');
    });
}

/**
 * Photo gallery slider ajax
 */
function PhotoGallerySlider(){

    var popup = $('.popup').first();
    var target = popup.find('.popup-content');

    $('.gallery').on('click',function(){
        // fetch images      

        $.ajax({
            url: $(this).data('url') + 'PhotoGallerySlider/',
            method: 'POST',
            data: 'SlideID=' + $(this).data('id'),
            context: this,
            success: function( response ){
                target.html( response );
                
                current_slide = $(this).data('id');
                $('a[data-id="'+ current_slide +'"').addClass('current').show();
            },
            error: function( response ){
                alert('There was a problem, please try again');
            }
        });
    });

}
